import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

import CascateList from "../../../../../../common/components/cascate_list";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * Header
 */

type Props = {
  statusChecklist: number;
  statusVerificacao: number;
  onChangeStatusChecklist: (newValue: number) => void;
  onChangeStatusVerificacao: (newValue: number) => void;
  onClearFilter: () => void;
};

export const Header = ({
  statusChecklist,
  statusVerificacao,
  onChangeStatusChecklist,
  onChangeStatusVerificacao,
  onClearFilter,
}: Props) => {
  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full flex flex-col gap-6 items-center justify-center">
        <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 grid-flow-row-dense">
          <FormControl size="small" fullWidth>
            <InputLabel id="modulo-dashboard">
              Status Checklist
            </InputLabel>
            <Select
              labelId="modulo-dashboard"
              label="Status Checklist"
              value={statusChecklist}
              onChange={e => onChangeStatusChecklist(Number(e.target.value))}>
              <MenuItem value={2}>Todos</MenuItem>
              <MenuItem value={0}>Em Elaboração</MenuItem>
              <MenuItem value={1}>Finalizados</MenuItem>
            </Select>
          </FormControl>

          <FormControl size="small" fullWidth>
            <InputLabel id="modulo-dashboard">
              Status Verificação
            </InputLabel>
            <Select
              labelId="modulo-dashboard"
              label="Status Verificação"
              value={statusVerificacao}
              onChange={e => onChangeStatusVerificacao(Number(e.target.value))}>
              <MenuItem value={3}>Todos</MenuItem>
              <MenuItem value={0}>Aprovados</MenuItem>
              <MenuItem value={1}>Reprovados</MenuItem>
              <MenuItem value={2}>Retrabalho</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className="w-full flex justify-end">
          <div className="w-[180px]">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
              buttonColor="yellow"
              onClick={onClearFilter}>
              Limpar filtros
            </PrimaryButton>
          </div>
        </div>
      </div>
    </CascateList>
  );
}